<div class="reward-token-expire">
    @if (isRewardDrawerEnabled && iconImageUrl) {
        <img [src]="iconImageUrl" />
    } @else {
        <i [ngClass]="expiryIcon"></i>
    }
    <span [ngClass]="{ 'expire-text': isDisabled }">{{ expires }} </span>
</div>
<div class="reward-token-buttons">
    <bs-reward-token-card-info-link
        class="reward-token-details"
        [token]="token"
        [withArrow]="false"
        [overrideLinkTitleHtml]="linkTitle"
        [promoHubUrlTokenType]="promoHubUrlTokenType"
        [tokenTitle]="tokenTitle"
        [tokenCategories]="tokenCategories"
        (betNowClicked)="betNowRedirect()"></bs-reward-token-card-info-link>

    <button class="reward-token-bet-now" (click)="betNowRedirect()">{{ sitecore.crmTokens.cards.BetNow }}</button>
</div>
